/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vagrant Box Registry
 * API for managing Vagrant boxes.
 *
 * The version of the OpenAPI document: 2022-09-30
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudVagrant20220930CreateBoxResponseFromJSON, HashicorpCloudVagrant20220930DeleteBoxResponseFromJSON, HashicorpCloudVagrant20220930ListBoxesResponseFromJSON, HashicorpCloudVagrant20220930ReadBoxResponseFromJSON, HashicorpCloudVagrant20220930UpdateBoxResponseFromJSON, InlineObjectToJSON, InlineObject1ToJSON, } from '../models';
/**
 *
 */
export class BoxServiceApi extends runtime.BaseAPI {
    /**
     * CreateBox creates a new Vagrant Box.
     */
    async createBoxRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling createBox.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createBox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObjectToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930CreateBoxResponseFromJSON(jsonValue));
    }
    /**
     * CreateBox creates a new Vagrant Box.
     */
    async createBox(registry, body) {
        const response = await this.createBoxRaw({ registry: registry, body: body });
        return await response.value();
    }
    /**
     * Deleting a Box removes all its Versions and Providers as well. This operation cannot be undone.
     * DeleteBox deletes a Vagrant Box.
     */
    async deleteBoxRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling deleteBox.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling deleteBox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930DeleteBoxResponseFromJSON(jsonValue));
    }
    /**
     * Deleting a Box removes all its Versions and Providers as well. This operation cannot be undone.
     * DeleteBox deletes a Vagrant Box.
     */
    async deleteBox(registry, box) {
        const response = await this.deleteBoxRaw({ registry: registry, box: box });
        return await response.value();
    }
    /**
     * ListBoxes lists all of the Boxes within a particular Registry.
     */
    async listBoxesRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling listBoxes.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930ListBoxesResponseFromJSON(jsonValue));
    }
    /**
     * ListBoxes lists all of the Boxes within a particular Registry.
     */
    async listBoxes(registry, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listBoxesRaw({ registry: registry, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * ReadBox reads a Vagrant Box.
     */
    async readBoxRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling readBox.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling readBox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930ReadBoxResponseFromJSON(jsonValue));
    }
    /**
     * ReadBox reads a Vagrant Box.
     */
    async readBox(registry, box) {
        const response = await this.readBoxRaw({ registry: registry, box: box });
        return await response.value();
    }
    /**
     * Note that this only updates details about the Box itself. To work with a Box\'s Versions or Providers, use those respective services.
     * UpdateBox updates the details of a Vagrant Box.
     */
    async updateBoxRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling updateBox.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling updateBox.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateBox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject1ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930UpdateBoxResponseFromJSON(jsonValue));
    }
    /**
     * Note that this only updates details about the Box itself. To work with a Box\'s Versions or Providers, use those respective services.
     * UpdateBox updates the details of a Vagrant Box.
     */
    async updateBox(registry, box, body) {
        const response = await this.updateBoxRaw({ registry: registry, box: box, body: body });
        return await response.value();
    }
}
